import {
  TBusinessFormData,
  TCategoryFormData,
  TEmployeeFormData,
  TEventFormData,
  TGroupFormData,
  THistoryFormData,
  TMainVisualFormData,
  TMaterialsFormData,
  TNewsFormData,
  TNoticeFormData,
  TPartnerFormData,
  TPopupFormData,
  TRecruitFormData,
  TSettingsField,
  TSettingsFormData,
} from 'src/@types';
import {
  IBusiness,
  ICategory,
  IEmployee,
  IEvent,
  IGroup,
  IHistory,
  ILabelValueModel,
  IMainVisual,
  IMaterials,
  INews,
  INotice,
  IPartner,
  IPopup,
  IRecruit,
} from 'src/models';
import { ISettings } from 'src/models/management/settings/Settings';
import {
  INIT_BUSINESS_FORM_DATA,
  INIT_CATEGORY_FORM_DATA,
  INIT_EMPLOYEE_FORM_DATA,
  INIT_EVENT_FORM_DATA,
  INIT_GROUP_FORM_DATA,
  INIT_HISTORY_FORM_DATA,
  INIT_MAIN_VISUAL_FORM_DATA,
  INIT_MATERIAL_FORM_DATA,
  INIT_NEWS_FORM_DATA,
  INIT_NOTICE_FORM_DATA,
  INIT_PARTNER_FORM_DATA,
  INIT_POPUP_FORM_DATA,
  INIT_RECRUIT_FORM_DATA,
  INIT_SETTINGS_FORM_DATA,
} from 'src/static/constants';

// popup form에 초기값 생성하는 합수
export const getPopupFormDefaultValues = (popup?: IPopup): TPopupFormData => {
  return popup
    ? {
        title: popup.title || INIT_POPUP_FORM_DATA.title,
        langCd: popup.langCd || INIT_POPUP_FORM_DATA.langCd,
        descript: popup.descript || INIT_POPUP_FORM_DATA.descript,
        useYn: popup.useYn || INIT_POPUP_FORM_DATA.useYn,
        delYn: popup.delYn || INIT_POPUP_FORM_DATA.delYn,
        startDt: popup.startDt || INIT_POPUP_FORM_DATA.startDt,
        endDt: popup.endDt || INIT_POPUP_FORM_DATA.endDt,
        width: popup.width || INIT_POPUP_FORM_DATA.width,
        height: popup.height || INIT_POPUP_FORM_DATA.height,
        popupEnvCd: popup.popupEnvCd?.code || INIT_POPUP_FORM_DATA.popupEnvCd,
        inactiveTime: popup.inactiveTime || INIT_POPUP_FORM_DATA.inactiveTime,
        topPosition: popup.topPosition ?? INIT_POPUP_FORM_DATA.topPosition,
        leftPosition: popup.leftPosition ?? INIT_POPUP_FORM_DATA.leftPosition,
      }
    : INIT_POPUP_FORM_DATA;
};
// employee form에 초기값 생성하는 합수
export const getEmployeeFormDefaultValues = (employee?: IEmployee): TEmployeeFormData => {
  const selectedOprtrGroupList = employee?.oprtrGroupList?.map((item) => {
    return {
      label: item.oprtrGroupNm,
      value: item.oprtrGroupSid,
    };
  });
  return employee
    ? {
        oprtrSid: employee.oprtrSid || INIT_EMPLOYEE_FORM_DATA.oprtrSid,
        loginId: employee.loginId || INIT_EMPLOYEE_FORM_DATA.loginId,
        oprtrNm: employee.oprtrNm || INIT_EMPLOYEE_FORM_DATA.oprtrNm,
        oprtrGroupSid: employee.oprtrGroupSid || INIT_EMPLOYEE_FORM_DATA.oprtrGroupSid,
        oprtrGroupSidList: employee.oprtrGroupSidList || INIT_EMPLOYEE_FORM_DATA.oprtrGroupSidList,
        oprtrGroupList: selectedOprtrGroupList || INIT_EMPLOYEE_FORM_DATA.oprtrGroupList,
        oprtrSttsCd: employee.oprtrSttsCd?.code || INIT_EMPLOYEE_FORM_DATA.oprtrSttsCd,
        beforePwd: INIT_EMPLOYEE_FORM_DATA.beforePwd,
        pwd: INIT_EMPLOYEE_FORM_DATA.pwd,
        pwdCorrect: INIT_EMPLOYEE_FORM_DATA.pwdCorrect,
        regDt: employee.regDt || INIT_EMPLOYEE_FORM_DATA.regDt,
        updDt: employee.updDt || INIT_EMPLOYEE_FORM_DATA.updDt,
      }
    : INIT_EMPLOYEE_FORM_DATA;
};

// notice form에 초기값 생성하는 합수
export const getNoticeFormDefaultValues = (notice?: INotice): TNoticeFormData => {
  return notice
    ? {
        noticeSid: notice.noticeSid || INIT_NOTICE_FORM_DATA.noticeSid,
        prNotiCtgyCd: notice.prNotiCtgyCd?.code || INIT_NOTICE_FORM_DATA.prNotiCtgyCd,
        title: notice.title || INIT_NOTICE_FORM_DATA.title,
        descript: notice.descript || INIT_NOTICE_FORM_DATA.descript,
        filePath: notice.filePath || INIT_NOTICE_FORM_DATA.filePath,
        deleteFilesPath: INIT_NOTICE_FORM_DATA.deleteFilesPath,
        regDt: notice.regDt || INIT_NOTICE_FORM_DATA.regDt,
        updDt: notice.updDt || INIT_NOTICE_FORM_DATA.updDt,
      }
    : INIT_NOTICE_FORM_DATA;
};
// news form에 초기값 생성하는 합수
export const getNewsFormDefaultValues = (news?: INews): TNewsFormData => {
  return news
    ? {
        newsSid: news.newsSid || INIT_NEWS_FORM_DATA.newsSid,
        prNewsCtgyCd: news.prNewsCtgyCd?.code || INIT_NEWS_FORM_DATA.prNewsCtgyCd,
        source: news.source || INIT_NEWS_FORM_DATA.source,
        title: news.title || INIT_NEWS_FORM_DATA.title,
        link: news.link || INIT_NEWS_FORM_DATA.link,
        descript: news.descript || INIT_NEWS_FORM_DATA.descript,
        filePath: news.filePath || INIT_NEWS_FORM_DATA.filePath,
        files: INIT_NEWS_FORM_DATA.files,
        deleteFilesPath: INIT_NEWS_FORM_DATA.deleteFilesPath,
        regDt: news.regDt || INIT_NEWS_FORM_DATA.regDt,
        updDt: news.updDt || INIT_NEWS_FORM_DATA.updDt,
        originRegDt: news.originRegDt || INIT_NEWS_FORM_DATA.originRegDt,
      }
    : INIT_NEWS_FORM_DATA;
};
// recruit form에 초기값 생성하는 합수
export const getRecruitFormDefaultValues = (recruit?: IRecruit): TRecruitFormData => {
  return recruit
    ? {
        recruitSid: recruit.recruitSid || INIT_RECRUIT_FORM_DATA.recruitSid,
        expCd: recruit.expCd?.code || INIT_RECRUIT_FORM_DATA.expCd,
        applyFieldCd: recruit.applyFieldCd?.code || INIT_RECRUIT_FORM_DATA.applyFieldCd,
        veteranCd: recruit.veteranCd?.code || INIT_RECRUIT_FORM_DATA.veteranCd,
        disabledCd: recruit.disabledCd?.code || INIT_RECRUIT_FORM_DATA.disabledCd,
        nameKr: recruit.nameKr || INIT_RECRUIT_FORM_DATA.nameKr,
        nameEn: recruit.nameEn || INIT_RECRUIT_FORM_DATA.nameEn,
        desiredSalary: recruit.desiredSalary || INIT_RECRUIT_FORM_DATA.desiredSalary,
        genderTypeCd: recruit.genderTypeCd?.code || INIT_RECRUIT_FORM_DATA.genderTypeCd,
        email: recruit.email || INIT_RECRUIT_FORM_DATA.email,
        phone: recruit.phone || INIT_RECRUIT_FORM_DATA.phone,
        emergencyContact: recruit.emergencyContact || INIT_RECRUIT_FORM_DATA.emergencyContact,
        birthDate: recruit.birthDate || INIT_RECRUIT_FORM_DATA.birthDate,
        calendarTypeCd: recruit.calendarTypeCd?.code || INIT_RECRUIT_FORM_DATA.calendarTypeCd,
        applySrc: recruit.applySrc || INIT_RECRUIT_FORM_DATA.applySrc,
        address: recruit.address || INIT_RECRUIT_FORM_DATA.address,
        resumeFilePath: recruit.resumeFilePath || INIT_RECRUIT_FORM_DATA.resumeFilePath,
        applyDt: recruit.applyDt || INIT_RECRUIT_FORM_DATA.applyDt,
        recruitStatusCd: recruit.recruitStatusCd?.code || INIT_RECRUIT_FORM_DATA.recruitStatusCd,
        memo: recruit.memo || INIT_RECRUIT_FORM_DATA.memo,
      }
    : INIT_RECRUIT_FORM_DATA;
};

export const getGroupFormDefaultValues = (group?: IGroup): TGroupFormData => {
  return group
    ? {
        oprtrGroupSid: group.oprtrGroupSid || INIT_GROUP_FORM_DATA.oprtrGroupSid,
        oprtrGroupNm: group.oprtrGroupNm || INIT_GROUP_FORM_DATA.oprtrGroupNm,
        dscrpt: group.dscrpt || INIT_GROUP_FORM_DATA.dscrpt,
        useYn: group.useYn || INIT_GROUP_FORM_DATA.useYn,
        roleIdList: group.roleIdList || INIT_GROUP_FORM_DATA.roleIdList,
      }
    : INIT_GROUP_FORM_DATA;
};
// 메인 비주얼
export const getMainVisualFormDefaultValues = (mainVisual?: IMainVisual): TMainVisualFormData => {
  return mainVisual
    ? {
        visualSid: mainVisual.visualSid || INIT_MAIN_VISUAL_FORM_DATA.visualSid,
        files: [],
        deleteFilesPath: [],
        useYn: mainVisual.useYn ?? INIT_MAIN_VISUAL_FORM_DATA.useYn,
        ordr: mainVisual.ordr || INIT_MAIN_VISUAL_FORM_DATA.ordr,
        langCd: mainVisual.langCd || INIT_MAIN_VISUAL_FORM_DATA.langCd,
        mainText: mainVisual.mainText || INIT_MAIN_VISUAL_FORM_DATA.mainText,
        subText: mainVisual.subText || INIT_MAIN_VISUAL_FORM_DATA.subText,
        mainTextColor: mainVisual.mainTextColor || INIT_MAIN_VISUAL_FORM_DATA.mainTextColor,
        subTextColor: mainVisual.subTextColor || '#000',
        bgPath: mainVisual.bgPath || [],
      }
    : INIT_MAIN_VISUAL_FORM_DATA;
};
// 회사 연혁
export const getHistoryFormDefaultValues = (history?: IHistory): THistoryFormData => {
  return history
    ? {
        historySid: history.historySid || INIT_HISTORY_FORM_DATA.historySid,
        useYn: history.useYn || INIT_HISTORY_FORM_DATA.useYn,
        applyStDay: INIT_HISTORY_FORM_DATA.applyStDay,
        historyDate: history.historyDate || INIT_HISTORY_FORM_DATA.historyDate,
        titleKo: history.titleKo || INIT_HISTORY_FORM_DATA.titleKo,
        titleEn: history.titleEn || INIT_HISTORY_FORM_DATA.titleEn,
        descript: history.descript || INIT_HISTORY_FORM_DATA.descript,
      }
    : INIT_HISTORY_FORM_DATA;
};
// 회사 파트너
export const getPartnerFormDefaultValues = (partner?: IPartner): TPartnerFormData => {
  return partner
    ? {
        partnerSid: partner.partnerSid || INIT_PARTNER_FORM_DATA.partnerSid,
        partnerName: partner.partnerName || INIT_PARTNER_FORM_DATA.partnerName,
        logoImgPath: partner.logoImgPath || INIT_PARTNER_FORM_DATA.logoImgPath,
        logoImgFile: INIT_PARTNER_FORM_DATA.logoImgFile,
        useYn: partner.useYn ?? INIT_PARTNER_FORM_DATA.useYn,
        ordr: partner.ordr || INIT_PARTNER_FORM_DATA.ordr,
        partnerCtgyCd: partner.partnerCtgyCd?.code || INIT_PARTNER_FORM_DATA.partnerCtgyCd,
      }
    : INIT_PARTNER_FORM_DATA;
};
// 이벤트(스케줄)
export const getEventFormDefaultValues = (event?: IEvent): TEventFormData => {
  return event
    ? {
        eventSid: event.eventSid || INIT_EVENT_FORM_DATA.eventSid,
        eventTypeCd: event.eventTypeCd?.code || INIT_EVENT_FORM_DATA.eventTypeCd,
        startDt: event.startDt || INIT_EVENT_FORM_DATA.startDt,
        title: event.title || INIT_EVENT_FORM_DATA.title,
        location: event.location || INIT_EVENT_FORM_DATA.location,
        descript: event.descript || INIT_EVENT_FORM_DATA.descript,
        useYn: event.useYn ?? INIT_EVENT_FORM_DATA.useYn,
      }
    : INIT_EVENT_FORM_DATA;
};
// 자료실
export const getMaterialsFormDefaultValues = (material?: IMaterials): TMaterialsFormData => {
  return material
    ? {
        title: material.title || INIT_MATERIAL_FORM_DATA.title,
        langCd: material.langCd || INIT_MATERIAL_FORM_DATA.langCd,
        filePath: material.filePath || INIT_MATERIAL_FORM_DATA.filePath,
        files: INIT_MATERIAL_FORM_DATA.files,
        useYn: material?.useYn ?? INIT_MATERIAL_FORM_DATA.useYn,
        delYn: material.delYn || INIT_MATERIAL_FORM_DATA.delYn,
        materialSid: material.materialSid || INIT_MATERIAL_FORM_DATA.materialSid,
      }
    : INIT_MATERIAL_FORM_DATA;
};
// 카테고리
export const getCategoryFormDefaultValues = (
  category?: ICategory,
  langList?: ILabelValueModel[],
): TCategoryFormData => {
  if (category) {
    // 수정 시: 기존 데이터 기반으로 모든 언어 처리
    return {
      categoryPsid: category.categoryPsid || INIT_CATEGORY_FORM_DATA.categoryPsid,
      categorySid: category.categorySid || INIT_CATEGORY_FORM_DATA.categorySid,
      ctgyDpTypeCd: category.ctgyDpTypeCd?.code || INIT_CATEGORY_FORM_DATA.ctgyDpTypeCd,
      useYn: category.useYn ?? INIT_CATEGORY_FORM_DATA.useYn,
      ordr: category.ordr || INIT_CATEGORY_FORM_DATA.ordr,
      thumbnailPath: category.thumbnailPath || INIT_CATEGORY_FORM_DATA.thumbnailPath,
      thumbnail: INIT_CATEGORY_FORM_DATA.thumbnail,
      categoryInfoList:
        langList?.map((lang: ILabelValueModel) => {
          // 기존 데이터에서 해당 언어 정보 찾기
          const existingInfo = category.categoryInfoList?.find(
            (info) => info.langCd === String(lang.value),
          );

          if (existingInfo) {
            return {
              ...existingInfo,
              categoryInfoSid: existingInfo.categoryInfoSid,
              langCd: String(lang.value),
            };
          }

          // 해당 언어 정보가 없으면 새로 생성
          return {
            categoryInfoSid: 0 || null,
            langCd: String(lang.value),
            ordr: 0,
            categoryNm: '',
            mainTitle: '',
            mainDesc: '',
            subTitle: '',
            subDesc: '',
            pipeline: '',
            pipelineList: '',
          };
        }) ?? [],
    };
  }

  // 신규 등록 시: 모든 언어에 대한 빈 폼
  return {
    ...INIT_CATEGORY_FORM_DATA,
    categoryInfoList:
      langList?.map((lang: ILabelValueModel) => ({
        langCd: String(lang.value),
        ordr: 0,
        categoryNm: '',
        mainTitle: '',
        mainDesc: '',
        subTitle: '',
        subDesc: '',
        pipeline: '',
        pipelineList: '',
      })) ?? [],
  };
};
// 비즈니스
export const getBusinessFormDefaultValues = (business?: IBusiness): TBusinessFormData => {
  return business
    ? {
        categorySid: business.categorySid || INIT_BUSINESS_FORM_DATA.categorySid,
        pipelineSid: business.pipelineSid || INIT_BUSINESS_FORM_DATA.pipelineSid,
        useYn: business.useYn ?? INIT_BUSINESS_FORM_DATA.useYn,
        langCd: business.langCd || INIT_BUSINESS_FORM_DATA.langCd,
        ordr: business.ordr || INIT_BUSINESS_FORM_DATA.ordr,
        title: business.title || INIT_BUSINESS_FORM_DATA.title,
        link: business.link || INIT_BUSINESS_FORM_DATA.link,
        summary: business.summary || INIT_BUSINESS_FORM_DATA.summary,
        thumbPath: business.thumbPath || INIT_BUSINESS_FORM_DATA.thumbPath,
        desktopImgPath: business.desktopImgPath || INIT_BUSINESS_FORM_DATA.desktopImgPath,
        mobileImgPath: business.mobileImgPath || INIT_BUSINESS_FORM_DATA.mobileImgPath,
        descript: business.descript || INIT_BUSINESS_FORM_DATA.descript,
        businessSubList: business.businessSubList || INIT_BUSINESS_FORM_DATA.businessSubList,
      }
    : INIT_BUSINESS_FORM_DATA;
};
// 회사 설정
export const getSettingsFormDefaultValues = (settings?: ISettings[]): TSettingsFormData => {
  const defaultSettings: TSettingsField[] = [
    { ...INIT_SETTINGS_FORM_DATA, langCd: 'ko' },
    { ...INIT_SETTINGS_FORM_DATA, langCd: 'en' },
  ];

  if (!settings?.length) {
    return { companyInfos: defaultSettings };
  }

  // 각 언어별 데이터 찾기
  const koData = settings.find((item) => item.langCd === 'ko');
  const enData = settings.find((item) => item.langCd === 'en');

  // 각 언어별 데이터 매핑
  const mappedSettings = [
    {
      langCd: 'ko',
      companyNm: koData?.companyNm || INIT_SETTINGS_FORM_DATA.companyNm,
      descript: koData?.descript || INIT_SETTINGS_FORM_DATA.descript,
      logoImgPath: koData?.logoImgPath ?? INIT_SETTINGS_FORM_DATA.logoImgPath,
      locationImgPath: koData?.locationImgPath ?? INIT_SETTINGS_FORM_DATA.locationImgPath,
      companyIntroPath: koData?.companyIntroPath ?? INIT_SETTINGS_FORM_DATA.companyIntroPath,
      link: koData?.link ?? INIT_SETTINGS_FORM_DATA.link,
      address: koData?.address || INIT_SETTINGS_FORM_DATA.address,
      tel: koData?.tel || INIT_SETTINGS_FORM_DATA.tel,
      fax: koData?.fax || INIT_SETTINGS_FORM_DATA.fax,
      email: koData?.email || INIT_SETTINGS_FORM_DATA.email,
      copyright: koData?.copyright || INIT_SETTINGS_FORM_DATA.copyright,
      salesInquiry: koData?.salesInquiry || INIT_SETTINGS_FORM_DATA.salesInquiry,
      recruitmentInquiry: koData?.recruitmentInquiry || INIT_SETTINGS_FORM_DATA.recruitmentInquiry,
      privacyPolicy: koData?.privacyPolicy || INIT_SETTINGS_FORM_DATA.privacyPolicy,
      terms: koData?.terms || INIT_SETTINGS_FORM_DATA.terms,
    },
    {
      langCd: 'en',
      companyNm: enData?.companyNm || INIT_SETTINGS_FORM_DATA.companyNm,
      descript: enData?.descript || INIT_SETTINGS_FORM_DATA.descript,
      logoImgPath: enData?.logoImgPath ?? INIT_SETTINGS_FORM_DATA.logoImgPath,
      locationImgPath: enData?.locationImgPath ?? INIT_SETTINGS_FORM_DATA.locationImgPath,
      companyIntroPath: enData?.companyIntroPath ?? INIT_SETTINGS_FORM_DATA.companyIntroPath,
      link: enData?.link ?? INIT_SETTINGS_FORM_DATA.link,
      address: enData?.address || INIT_SETTINGS_FORM_DATA.address,
      tel: enData?.tel || INIT_SETTINGS_FORM_DATA.tel,
      fax: enData?.fax || INIT_SETTINGS_FORM_DATA.fax,
      email: enData?.email || INIT_SETTINGS_FORM_DATA.email,
      copyright: enData?.copyright || INIT_SETTINGS_FORM_DATA.copyright,
      salesInquiry: enData?.salesInquiry || INIT_SETTINGS_FORM_DATA.salesInquiry,
      recruitmentInquiry: enData?.recruitmentInquiry || INIT_SETTINGS_FORM_DATA.recruitmentInquiry,
      privacyPolicy: enData?.privacyPolicy || INIT_SETTINGS_FORM_DATA.privacyPolicy,
      terms: enData?.terms || INIT_SETTINGS_FORM_DATA.terms,
    },
  ];

  return {
    companyInfos: mappedSettings,
  };
};
